// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Notification.module.scss  */
/* stylelint-disable */
.Notification-module-Root_E_a {
  position: relative;
  display: grid;
  visibility: hidden;
  grid-template-areas: 'before title close' 'before text .' 'footer footer footer';
  grid-template-columns: auto 1fr 24px;
  grid-auto-rows: auto;
  box-sizing: border-box;
  width: 440px;
  padding: 16px 16px 16px 20px;
  border-radius: var(--notification-border-radius);
  background-color: var(--color-background-base);
  box-shadow: var(--notification-shadow);
  grid-gap: 0 8px; }
  @media (max-width: 767px) {
    .Notification-module-Root_E_a {
      width: 100%; } }

.Notification-module-slideInUpAnimation_3Nv {
  visibility: visible;
  animation: Notification-module-slideInUp_12k 500ms ease-in; }
  @media (max-width: 767px) {
    .Notification-module-slideInUpAnimation_3Nv {
      animation: Notification-module-slideInDown_1XQ 500ms cubic-bezier(0.88, 0.29, 0.44, 0.91); } }

.Notification-module-dissolveAnimation_5Pa {
  animation: Notification-module-dissolve_2Hr 1000ms ease-in; }
  @media (max-width: 767px) {
    .Notification-module-dissolveAnimation_5Pa {
      animation: Notification-module-dissolve_2Hr 0.25s linear; } }

.Notification-module-Title_1NJ {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  grid-area: title;
  margin: 0;
  font-weight: 600; }

.Notification-module-Text_2Xj {
  grid-area: text;
  margin: 8px 0 0;
  color: var(--notification-text-color); }

.Notification-module-AddonBottom_3pN {
  display: flex;
  align-items: center;
  column-gap: 8px;
  grid-area: footer;
  margin-top: 16px; }

.Notification-module-Btn_20v {
  font-size: var(--typography-p2-font-size);
  font-weight: 600; }
  .Notification-module-Btn_20v .Notification-module-Text_2Xj {
    margin: 0; }

.Notification-module-Close_307 {
  display: flex;
  grid-area: close;
  padding: 0;
  cursor: pointer;
  color: #9199a3;
  border: none;
  background-color: transparent; }
  .Notification-module-Close_307 svg {
    margin-bottom: auto; }
  .Notification-module-Close_307:hover {
    color: var(--color-base); }

.Notification-module-AddonBefore_t6d {
  grid-area: before; }

[data-variant='dark'] {
  background-color: var(--notification-dark-background-color); }
  [data-variant='dark'] .Notification-module-Title_1NJ {
    color: var(--notification-dark-title-color); }
  [data-variant='dark'] .Notification-module-Text_2Xj {
    color: var(--notification-dark-text-color); }
  [data-variant='dark'] .Notification-module-AddonBefore_t6d svg {
    fill: var(--notification-dark-title-color); }
  [data-variant='dark'] .Notification-module-Close_307 svg {
    fill: var(--notification-dark-text-color); }
  [data-variant='dark'] .Notification-module-Close_307:hover svg {
    fill: var(--notification-dark-text-color); }

@keyframes Notification-module-slideInUp_12k {
  from {
    opacity: 0.01;
    transform: translate3d(0, 100%, 0); }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0); } }

@keyframes Notification-module-slideInDown_1XQ {
  from {
    opacity: 0.01;
    transform: translate3d(0, -100%, 0); }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0); } }

@keyframes Notification-module-dissolve_2Hr {
  from {
    visibility: visible;
    opacity: 1; }
  to {
    opacity: 0; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Notification/Notification.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gFAAgF;EAChF,oCAAoC;EACpC,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,gDAAgD;EAChD,8CAA8C;EAC9C,sCAAsC;EACtC,eAAe,EAAE;EACjB;IACE;MACE,WAAW,EAAE,EAAE;;AAErB;EACE,mBAAmB;EACnB,0DAA0D,EAAE;EAC5D;IACE;MACE,yFAAyF,EAAE,EAAE;;AAEnG;EACE,0DAA0D,EAAE;EAC5D;IACE;MACE,wDAAwD,EAAE,EAAE;;AAElE;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,eAAe;EACf,qCAAqC,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB,EAAE;;AAEpB;EACE,yCAAyC;EACzC,gBAAgB,EAAE;EAClB;IACE,SAAS,EAAE;;AAEf;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ,6BAA6B,EAAE;EAC/B;IACE,mBAAmB,EAAE;EACvB;IACE,wBAAwB,EAAE;;AAE9B;EACE,iBAAiB,EAAE;;AAErB;EACE,2DAA2D,EAAE;EAC7D;IACE,2CAA2C,EAAE;EAC/C;IACE,0CAA0C,EAAE;EAC9C;IACE,0CAA0C,EAAE;EAC9C;IACE,yCAAyC,EAAE;EAC7C;IACE,yCAAyC,EAAE;;AAE/C;EACE;IACE,aAAa;IACb,kCAAkC,EAAE;EACtC;IACE,UAAU;IACV,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,aAAa;IACb,mCAAmC,EAAE;EACvC;IACE,UAAU;IACV,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,mBAAmB;IACnB,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE","sourcesContent":["/*  imported from Notification.module.scss  */\n/* stylelint-disable */\n.Notification-module-Root_E_a {\n  position: relative;\n  display: grid;\n  visibility: hidden;\n  grid-template-areas: 'before title close' 'before text .' 'footer footer footer';\n  grid-template-columns: auto 1fr 24px;\n  grid-auto-rows: auto;\n  box-sizing: border-box;\n  width: 440px;\n  padding: 16px 16px 16px 20px;\n  border-radius: var(--notification-border-radius);\n  background-color: var(--color-background-base);\n  box-shadow: var(--notification-shadow);\n  grid-gap: 0 8px; }\n  @media (max-width: 767px) {\n    .Notification-module-Root_E_a {\n      width: 100%; } }\n\n.Notification-module-slideInUpAnimation_3Nv {\n  visibility: visible;\n  animation: Notification-module-slideInUp_12k 500ms ease-in; }\n  @media (max-width: 767px) {\n    .Notification-module-slideInUpAnimation_3Nv {\n      animation: Notification-module-slideInDown_1XQ 500ms cubic-bezier(0.88, 0.29, 0.44, 0.91); } }\n\n.Notification-module-dissolveAnimation_5Pa {\n  animation: Notification-module-dissolve_2Hr 1000ms ease-in; }\n  @media (max-width: 767px) {\n    .Notification-module-dissolveAnimation_5Pa {\n      animation: Notification-module-dissolve_2Hr 0.25s linear; } }\n\n.Notification-module-Title_1NJ {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  grid-area: title;\n  margin: 0;\n  font-weight: 600; }\n\n.Notification-module-Text_2Xj {\n  grid-area: text;\n  margin: 8px 0 0;\n  color: var(--notification-text-color); }\n\n.Notification-module-AddonBottom_3pN {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n  grid-area: footer;\n  margin-top: 16px; }\n\n.Notification-module-Btn_20v {\n  font-size: var(--typography-p2-font-size);\n  font-weight: 600; }\n  .Notification-module-Btn_20v .Notification-module-Text_2Xj {\n    margin: 0; }\n\n.Notification-module-Close_307 {\n  display: flex;\n  grid-area: close;\n  padding: 0;\n  cursor: pointer;\n  color: #9199a3;\n  border: none;\n  background-color: transparent; }\n  .Notification-module-Close_307 svg {\n    margin-bottom: auto; }\n  .Notification-module-Close_307:hover {\n    color: var(--color-base); }\n\n.Notification-module-AddonBefore_t6d {\n  grid-area: before; }\n\n[data-variant='dark'] {\n  background-color: var(--notification-dark-background-color); }\n  [data-variant='dark'] .Notification-module-Title_1NJ {\n    color: var(--notification-dark-title-color); }\n  [data-variant='dark'] .Notification-module-Text_2Xj {\n    color: var(--notification-dark-text-color); }\n  [data-variant='dark'] .Notification-module-AddonBefore_t6d svg {\n    fill: var(--notification-dark-title-color); }\n  [data-variant='dark'] .Notification-module-Close_307 svg {\n    fill: var(--notification-dark-text-color); }\n  [data-variant='dark'] .Notification-module-Close_307:hover svg {\n    fill: var(--notification-dark-text-color); }\n\n@keyframes Notification-module-slideInUp_12k {\n  from {\n    opacity: 0.01;\n    transform: translate3d(0, 100%, 0); }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n\n@keyframes Notification-module-slideInDown_1XQ {\n  from {\n    opacity: 0.01;\n    transform: translate3d(0, -100%, 0); }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n\n@keyframes Notification-module-dissolve_2Hr {\n  from {\n    visibility: visible;\n    opacity: 1; }\n  to {\n    opacity: 0; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
